import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'qpx-grid-item-details',
    template: `<ng-content />`,
    styleUrl: './details.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QpxGridItemDetails {}
